const APEX_CHART_LOCALE_NAME = 'specific'

const padDatePart = (value) => String(value).padStart(2, '0')

const getDateFromAxisValue = (value, timestamp) => {
  const sourceValue = timestamp ?? value
  const date = new Date(sourceValue)

  if (Number.isNaN(date.getTime())) {
    return null
  }

  return date
}

const getTimestampFromAxisValue = (value, timestamp) => {
  const sourceValue = Number(timestamp ?? value)

  if (!Number.isFinite(sourceValue)) {
    return null
  }

  return Math.round(sourceValue)
}

const formatDateAxisLabel = (value, timestamp) => {
  const date = getDateFromAxisValue(value, timestamp)

  if (!date) {
    return String(value || '')
  }

  return `${padDatePart(date.getDate())}/${padDatePart(date.getMonth() + 1)}/${date.getFullYear()}`
}

const createDateAxisLabelFormatter = (timestamps) => (value, timestamp) => {
  if (timestamps.size > 0 && !timestamps.has(getTimestampFromAxisValue(value, timestamp))) {
    return ''
  }

  return formatDateAxisLabel(value, timestamp)
}

export const getApexChartLocaleOptions = (t) => ({
  defaultLocale: APEX_CHART_LOCALE_NAME,
  locales: [
    {
      name: APEX_CHART_LOCALE_NAME,
      options: {
        toolbar: {
          exportToSVG: t('reports:ndvi.view.charts.toolbar.export_svg'),
          exportToPNG: t('reports:ndvi.view.charts.toolbar.export_png'),
          exportToCSV: t('reports:ndvi.view.charts.toolbar.export_csv'),
          menu: t('reports:ndvi.view.charts.toolbar.menu'),
          selection: t('reports:ndvi.view.charts.toolbar.selection'),
          selectionZoom: t('reports:ndvi.view.charts.toolbar.selection_zoom'),
          zoomIn: t('reports:ndvi.view.charts.toolbar.zoom_in'),
          zoomOut: t('reports:ndvi.view.charts.toolbar.zoom_out'),
          pan: t('reports:ndvi.view.charts.toolbar.pan'),
          reset: t('reports:ndvi.view.charts.toolbar.reset'),
        },
      },
    },
  ],
})

export const getNdviLineChartDisplayOptions = ({ dateTimestamps = [] } = {}) => {
  const timestamps = new Set(
    dateTimestamps
      .map((dateTimestamp) => getTimestampFromAxisValue(dateTimestamp))
      .filter((dateTimestamp) => dateTimestamp != null)
  )
  const axisLabelFormatter = createDateAxisLabelFormatter(timestamps)

  return {
    stroke: {
      curve: 'smooth',
      lineCap: 'round',
      width: 4,
    },
    markers: {
      size: 0,
    },
    grid: {
      padding: {
        bottom: 26,
      },
    },
    tooltip: {
      x: {
        formatter: (value) => formatDateAxisLabel(value),
      },
    },
    xaxis: {
      type: 'numeric',
      tickAmount: 'dataPoints',
      decimalsInFloat: 0,
      axisTicks: {
        show: false,
      },
      labels: {
        formatter: axisLabelFormatter,
        hideOverlappingLabels: true,
        show: false,
        rotate: -45,
        rotateAlways: true,
        style: {
          fontSize: '11px',
        },
        trim: false,
      },
    },
  }
}
